﻿window.cTableChampData = function(bddRef, lstChampTableData) {

    //poiur les champs unitaires
    this.mGetChampTableData = function (chpTable) {
        var chpTableData = lstChampTableData.filter(function (o) { return o.id_champ_table == chpTable.id_champ_table })[0]
        return chpTableData
    }
    //pour les listes
    this.mGetLstChampTableData = function (chpTable) {
        return lstChampTableData.filter(function (o) { return o.id_champ_table == chpTable.id_champ_table })
    }

    this.mGetAdressePostaleDefaut = function () {
        var adr = lstChampTableData.filter(function (o) {
            return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 8 && o.defaut == 1
        }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        if (typeof adr == 'undefined') {
            adr = lstChampTableData.filter(function (o) {
                return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 8
            }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        }
        if (typeof adr == 'undefined') { return null } else { return adr }
    }

    this.mGetAdresseEmailDefaut = function () {
        var adr = lstChampTableData.filter(function (o) {
            return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 7 && o.defaut == 1
        }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        if (typeof adr == 'undefined') {
            adr = lstChampTableData.filter(function (o) {
                return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 7
            }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        }
        if (typeof adr == 'undefined') { return null } else { return adr }
    }

    this.mGetTelephoneDefaut = function () {
        var adr = lstChampTableData.filter(function (o) {
            return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 16 && o.defaut == 1
        }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        if (typeof adr == 'undefined') {
            adr = lstChampTableData.filter(function (o) {
                return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 16
            }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        }
        if (typeof adr == 'undefined') { return null } else { return adr }
    }

    this.mGetMobileDefaut = function () {
        var adr = lstChampTableData.filter(function (o) {
            return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 17 && o.defaut == 1
        }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        if (typeof adr == 'undefined') {
            adr = lstChampTableData.filter(function (o) {
                return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 17
            }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        }
        if (typeof adr == 'undefined') { return null } else { return adr }
    }

    this.mGetSiteDefaut = function () {
        var adr = lstChampTableData.filter(function (o) {
            return bddRef.mGetArray("champ_table").filterFirst(function (oo) { return o.id_champ_table == oo.id_champ_table })[0].id_type_champ == 15
        }).sort(function (o1, o2) { return parseInt(o1.id_champ_table) - parseInt(o2.id_champ_table) })[0]
        if (typeof adr == 'undefined') { return null } else { return adr }
    }


    //sauvegarde d'un champ_table_data à partir d'un dxCtrlChampTable...
    this.mSaveChampTableData = function (nomKey, champ_table_data, objetMaitre, funcSave, onChange) {
        if (typeof champ_table_data.id == 'undefined' || champ_table_data.id == null) {
            if (typeof objetMaitre.cle() == "undefined" || objetMaitre.cle() == null) {
                objetMaitre.mSave(function (data) {
                    champ_table_data.id = objetMaitre.cle()
                    var obj = bddRef.getObjet(champ_table_data)
                    obj.mSave(function () {
                        if (typeof onChange != 'undefined') onChange("new", champ_table_data)
                    })
                })
            } else {
                champ_table_data.id = objetMaitre.cle()
                var obj = bddRef.getObjet(champ_table_data)
                obj.mSave(function () {
                    if (typeof onChange != 'undefined') onChange("new", champ_table_data)
                })
            }
        } else {
            var obj = bddRef.getObjet(champ_table_data)
            if (!obj.objetMetier.hasValue()) {
                //on a pas de valeur - on delete le champ_table_data
                if (champ_table_data[nomKey] != null) {
                    obj.mDelDataDefinitif(function () {
                        champ_table_data[nomKey] = null;
                        if (typeof onChange != 'undefined') onChange("supp", champ_table_data)
                    }, null, true)
                }
            } else {
                var typChange = ((typeof champ_table_data[nomKey] == 'undefined' || champ_table_data[nomKey] == null) ? "new" : "modif")
                funcSave(obj, function () {
                    if (typeof onChange != 'undefined' && onChange != null) onChange(typChange, champ_table_data)
                })
            }
        }
    }

}